<template>
  <div v-if="error" class="login-container">
    <!-- <img :src="birdLogo" class="birdLogo" alt="" /> -->
    <!-- <img :src="maxxifiedLogo" class="maxxifiedLogo" alt="" /> -->

    <div v-if="loading" class="loading-container">
      <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>

    <div v-else-if="error" class="error-container">
      <div class="error-content">
        <div class="error-icon">
          <i class="fas fa-exclamation-circle"></i>
        </div>
        <h3 class="error-title">Oops!</h3>
        <p class="error-message">{{ error }}</p>
        <button class="retry-button" @click="retryLoading"><i class="fas fa-redo"></i> Try Again</button>
      </div>
    </div>
  </div>
  <div v-else class="login-container">
    <!-- <img :src="birdLogo" class="birdLogo" alt="" /> -->

    <div class="maxxifiedLogoContainer">
      <img :src="tenantConfig?.logo ? tenantConfig.logo : maxxifiedLogo" class="newLogo" alt="" />
    </div>

    <p class="loginTitleNew">Login</p>
    <p class="loginSuitTitleNew">Welcome back! Log in to continue.</p>

    <div class="login-card">
      <form @submit.prevent="handleLogin" class="login-card-inner-section">
        <custom-input label="Username" type="text" placeholder="Email ID" :value="username" @update:value="username = $event" :error="errors.username" />
        <div class="inputDiv">
          <div class="password-input-wrapper">
            <custom-input label="Password" :type="showPassword ? 'text' : 'password'" placeholder="Password" :value="password" @update:value="password = $event" :error="errors.password" />
            <button type="button" class="password-toggle-btn" @click="togglePasswordVisibility">
              <svg v-if="showPassword" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24" />
                <line x1="1" y1="1" x2="23" y2="23" />
              </svg>
              <svg v-else xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                <circle cx="12" cy="12" r="3" />
              </svg>
            </button>
          </div>
        </div>

        <div class="buttonDiv">
          <custom-button :disabled="loading" @click="login">
            Next
            <div v-if="loading" class="spinner-border text-white spinner-grow-sm" role="status"></div>
          </custom-button>
        </div>
        <!-- <p class="forgotPasswordText">OR</p> -->
        <!-- In Login.vue -->
        <!-- <custom-button @click="$router.push('/register')">
          Go to Register
        </custom-button> -->

        <p class="forgotPasswordText" style="cursor: pointer" @click="goToForgotPassword">Forgot Password?</p>
        <!-- <p class="termsAndConditions">
          We use analytics to improve the application performance, for more information see Our <a class="highlightedText">Cookie</a> and
          <a class="highlightedText">Privacy Policy</a>
        </p> -->
      </form>
    </div>
    <Footer />
  </div>
</template>

<script>
import birdLogo from '@/assets/bird-logo.png'
import maxxifiedLogo from '@/assets/maxxified_logo.png'
import { useAuthStore } from '@/stores/authStore'
import CustomInput from '../../components/CustomInput.vue'
import CustomButton from '../../components/CustomButton.vue'
import { updateThemeColor } from '../../utils/theme.js'
import Footer from '../../components/Footer.vue'
import { get } from '@/utils/api'

export default {
  name: 'TenantConfig',
  data() {
    return {
      loading: true,
      error: null,
      tenantConfig: null,
      birdLogo,
      maxxifiedLogo,
      username: '',
      password: '',
      firstName: '',
      LastName: '',
      showPassword: false, // Password visibility toggle
      message: this.$route.query.message || null,
      errors: {
        username: '',
        password: '',
      },
    }
  },
  components: {
    CustomInput,
    CustomButton,
    Footer,
  },
  async created() {
    await this.fetchTenantConfig()
  },
  mounted() {
    localStorage.clear()
  },
  computed: {
    auth() {
      return useAuthStore()
    },
  },
  methods: {
    async fetchTenantConfig() {
      try {
        const tenantSlug = this.$route.params.tenantSlug
        const response = await get('/public/tenant-config', {
          key: 'url_name',
          value: tenantSlug,
        })

        if (response.data && response.data.data) {
          this.tenantConfig = response.data.data
          const selected_theme = this.tenantConfig?.selected_theme
          let primaryColor
          let secondaryColor
          if (selected_theme === 'Custom') {
            primaryColor = this.tenantConfig?.custom_primary_color
            secondaryColor = this.tenantConfig?.custom_secondary_color
          } else {
            primaryColor = this.tenantConfig?.theme_primary_color
            secondaryColor = this.tenantConfig?.theme_secondary_color
          }
          updateThemeColor(primaryColor, secondaryColor)
          if (response.data.data?.logo) {
            localStorage.setItem('logo', response.data.data?.logo)
          }
        } else {
          this.error = 'Tenant not found'
        }
      } catch (err) {
        this.error = 'Failed to load tenant configuration'
      } finally {
        this.loading = false
      }
    },
    async retryLoading() {
      this.loading = true
      this.error = null
      await this.fetchTenantConfig()
    },
    validateFields() {
      this.errors = { username: '', password: '' } // Reset errors

      if (!this.username) {
        this.errors.username = 'Please enter valid email address'
      }
      if (!this.password) {
        this.errors.password = 'Please enter valid Password'
      }

      return !this.errors.username && !this.errors.password // Return true if no errors
    },
    goToForgotPassword() {
      this.$router.push('/forgot-password')
    },
    togglePasswordVisibility() {
      this.showPassword = !this.showPassword
    },
    updateValue(event) {
      this.$emit('update:value', event.target.value)
    },
    async handleLogin() {
      if (!this.validateFields()) return // Stop if validation fails
      this.loading = true
      // this.$router.push('/dashboard')

      const loginResponse = await this.auth.login(this.username, this.password)
      if (loginResponse?.data?.code === 200) {
        const response2 = await get('/public/tenant-config', {
          key: 'email',
          value: this.username,
        })
        const tenantSlug = this.$route.params.tenantSlug
        console.log('response2', response2)
        if (response2.data.data.url_name !== tenantSlug) {
          this.errors.username = 'Please enter valid email Id'
          this.errors.password = 'Incorrect password, Please enter a valid password'
          this.loading = false
          // return
        } else {
          this.$router.push('/otp-verification')
        }
      } else {
        // Optionally handle error (already set in this.auth.error)
        this.errors.username = 'Please enter valid email Id'
        this.errors.password = 'Incorrect password, Please enter a valid password'
        this.loading = false
      }
      // this.loading = false
      // // if (!this.auth.error && this.auth.AccessToken) {
      // this.$router.push('/otp-verification')
      // }
    },
  },
}
</script>

<style scoped>
@import '@/styles/login.css';

.loading-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 200px;
}

.error-container {
  text-align: center;
  padding: 20px;
  animation: fadeIn 0.5s ease-in-out;
}

.error-content {
  background: #fff;
  padding: 30px;
  border-radius: 12px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
  max-width: 400px;
  margin: 0 auto;
}

.error-icon {
  font-size: 48px;
  color: #dc3545;
  margin-bottom: 15px;
  animation: bounce 1s ease infinite;
}

.error-title {
  color: #dc3545;
  font-size: 24px;
  margin-bottom: 10px;
  font-weight: 600;
}

.error-message {
  color: #666;
  font-size: 16px;
  margin-bottom: 20px;
  line-height: 1.5;
}

.retry-button {
  background: #007bff;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 6px;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.3s ease;
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.retry-button:hover {
  background: #0056b3;
  transform: translateY(-2px);
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes bounce {
  0%,
  100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-10px);
  }
}

.tenant-info {
  width: 100%;
  max-width: 400px;
  margin: 0 auto;
}

.tenant-details {
  padding: 20px;
}

.tenant-details p {
  margin: 10px 0;
  font-size: 1rem;
  color: #333;
}

.password-input-wrapper {
  position: relative;
  width: 100%;
}

.password-input-wrapper :deep(.input-wrapper) {
  position: relative;
}

.password-input-wrapper :deep(.input-wrapper input) {
  padding-right: 45px;
}

.password-toggle-btn {
  position: absolute;
  right: 12px;
  top: calc(19.58px + 10px + 5px + 23px);
  transform: translateY(-50%);
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #667085;
  z-index: 10;
  transition: color 0.2s;
  height: 20px;
  width: 20px;
  margin-top: 0;
}

.password-toggle-btn:hover {
  color: var(--primary-color, #164863);
}

.password-toggle-btn:focus {
  outline: none;
}

.password-toggle-btn svg {
  width: 20px;
  height: 20px;
  stroke-width: 2;
}
</style>
